import React, { useEffect, useState, useRef } from 'react';
import * as constants from '../../Utils/constants';
import Notifications from "../../Components/Notifications/Notifications";
//import { useTranslation } from 'react-i18next';

const NotificationAtom = (props) => {
    const ref = useRef(null);
    //const { t } = useTranslation();

    // let _notificationsStateName = [
    //     {
    //         type: t('pending'),
    //         active: true,
    //         className: "fa-hourglass-2"
    //     },
    //     {
    //         type: t('approved'),
    //         active: false,
    //         className: "fa-check"
    //     },
    //     {
    //         type: t('declined'),
    //         active: false,
    //         className: "fa-ban"
    //     },
    //     {
    //         type: t('choreAcknowledged'),
    //         active: false,
    //         className: "fa-file-text-o"
    //     }
    // ]

    //const [notificationsStateName, setnotificationsStateName] = useState();
    //const [viewAll, setviewAll] = useState(false);
    //const [toggleNotification, setToggleNotification] = useState(true);

    const [notifications, setnotifications] = useState({
        self: [],
        family: []
    })

    useEffect(() => {
        let isSubscribed = true
        //setnotificationsStateName(_notificationsStateName);

        props._list(constants.NOTIFICAIONS, null, res => {
            
            setnotifications(res)
        }, err => {
            isSubscribed = false;
        })
        return () => isSubscribed;

    }, [])// eslint-disable-line react-hooks/exhaustive-deps


    // const handleNotifyTab = (tabIndex) => {

    //     removeAllActiveTab();
    //     setviewAll(false);

    //     notificationsStateName[tabIndex].active = true;
    //     setnotificationsStateName([...notificationsStateName]);

    // }

    // const toggleNotific = () => {
    //     if (toggleNotification) {
    //         setToggleNotification(false);
    //     }
    //     else {
    //         setToggleNotification(true);
    //     }
    // }

    // const removeAllActiveTab = () => {
    //     notificationsStateName.forEach(element => {
    //         return element.active = false;
    //     });
    // }

    // if (!props.isNotification) {
    //     return <></>
    // }

    return (
        <div ref={ref}>
            <Notifications {...props} notifications={notifications} stateName={`ViewAll`} active={true} />
        </div>
    )
}

export default NotificationAtom;